import { apiFetchCartDrawerItems } from './api';
import { FETCH_CART_DRAWER_ITEMS } from './constants';

import { Dispatch } from '@shopee/flow-types';

export const fetchCartDrawerItems = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: FETCH_CART_DRAWER_ITEMS.REQUESTED,
    });
    const { response, error } = await apiFetchCartDrawerItems();
    if (!error && response) {
      dispatch({
        type: FETCH_CART_DRAWER_ITEMS.SUCCESS,
        data: response.data,
      });
    }
  };
};
